import React from "react"
import {connect} from "react-redux"
import PropTypes from "prop-types"
import ReportQuery from "@irati/insights/apollo/query/report/get"
import notify from "@irati/utils/notify"

import {injectIntl} from "@irati/utils/lang"
import {DemoTenantContext} from "@irati/insights/context"
import {overrideAuth} from "@irati/insights/utils/apollo"

import ReportActions from "../../store/actions/report"
import {REPORT_STATUSES} from "../../utils/constants/report"
import NotificationLink from "./NotificationLink"


const POLL_INTERVAL = 5000


const ReportStatusCheck = ({pendingReports, formatMessage, removePendingReport}, context) => (
  <DemoTenantContext>
    {({accessToken}) => {
      return pendingReports.map(({uuid, isDemo}) => (
        <ReportQuery key={uuid} variables={{uuid}} pollInterval={POLL_INTERVAL} {...overrideAuth(accessToken, isDemo)}>
          {({report: {status} = {}}) => {
            if (status === REPORT_STATUSES.failed) {
              removePendingReport(uuid)
              notify.light({
                message: "insights.reports.notification.error.text",
                status: "error",
                component: (remove) => <NotificationLink context={context} {...remove} />
              }, formatMessage)
            }

            if (status === REPORT_STATUSES.complete) {
              removePendingReport(uuid)
              notify.light({
                message: "insights.reports.notification.complete.text",
                status: "success",
                component: (remove) => <NotificationLink context={context} {...remove} />
              }, formatMessage)
            }
            return null
          }}
        </ReportQuery>
      ))
    }}
  </DemoTenantContext>
)


ReportStatusCheck.contextTypes = {
  appPath: PropTypes.string
}

ReportStatusCheck.propTypes = {
  pendingReports: PropTypes.array.isRequired,
  removePendingReport: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    pendingReports: state.insights.reports.pending
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    removePendingReport: (uuid) => dispatch(ReportActions.removePending(uuid))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ReportStatusCheck))
